import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IAddedEnrollCode, IFailedEnrollCode } from './enroll-codes-dialog.component';

export interface IEnrollCodesAddedDialogOptions {
    title: string;
    message?: string;
    codes: IAddedEnrollCode[];
    failedCodes: IFailedEnrollCode[];
    success: boolean;
    partialSuccess: boolean;
}

@Component({
    selector: 'app-enrollment-codes-added-dialog',
    templateUrl: './enroll-codes-added-dialog.component.html',
    styleUrl: './enroll-codes-added-dialog.component.scss',
    standalone: false,
})
export class EnrollCodesAddedDialogComponent {
    displayedColumns = [
        'endpointId',
        'product',
        'code',
        'usageLimit',
        'expiration',
    ];

    failedDisplayedColumns = [
        'endpointId',
        'endpointName',
        'product',
        'message',
    ];

    constructor(
        public readonly dialogRef: MatDialogRef<EnrollCodesAddedDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public options: IEnrollCodesAddedDialogOptions,
    ) {}

    ngOnDestroy(): void {
        this.options.codes.forEach(code => {code.code = '';});
        this.options.codes.length = 0;
    }

    downloadCsv(): void {
        const headers = [
            'Endpoint ID',
            'Product',
            'Code',
            'Usage Limit',
            'Expiration',
        ];

        const rows = this.options.codes.map(code => [
            code.endpointName,
            code.product,
            code.code,
            (code.usageLimit == -1) ? 'Unlimited' : code.usageLimit,
            (code.expiration === '0' || new Date(code.expiration).getTime() === 0)
                ? 'Never'
                : new Date(code.expiration).toLocaleDateString('en-US', {
                    timeZone: 'UTC',
                })
        ]);

        const csv = [
            headers,
            ...rows,
        ]
            .map(row =>
                row
                    .map(value => this.escapeCsvValue(value))
                    .join(',')
            )
            .join('\r\n');

        const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});

        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');

        anchor.href = url;
        anchor.download = 'enrollment-codes.csv';
        anchor.click();

        URL.revokeObjectURL(url);
    }

    private escapeCsvValue(value: unknown): string {
        const text = String(value ?? '');

        if (
            text.includes(',') ||
            text.includes('"') ||
            text.includes('\n')
        ) {
            return `"${text.replace(/"/g, '""')}"`;
        }

        return text;
    }

    close(): void {
        this.options.codes.forEach(code => {code.code = '';});
        this.options.codes.length = 0;
        
        this.dialogRef.close();
    }
}